(() => {
  const DESKTOP_MQ = '(min-width: 1100px)';

  const initStackedGalleryDots = (wrapper) => {
    if (wrapper.dataset.dotsBound === 'true') return;
    wrapper.dataset.dotsBound = 'true';

    const items = Array.from(
      wrapper.querySelectorAll('.product__media-list > .product__media-item')
    );
    const dotsNav = wrapper.querySelector('[data-gallery-dots]');
    if (!items.length || !dotsNav) return;

    const dots = Array.from(dotsNav.querySelectorAll('[data-gallery-dot]'));
    if (!dots.length) return;

    let isClickScrolling = false;
    let clickScrollTimeout;
    let activeIndex = 0;

    const setActive = (index) => {
      if (index < 0 || index >= dots.length) return;
      if (index === activeIndex && dots[index].classList.contains('is-active')) return;
      activeIndex = index;
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const getActiveIndex = () => {
      const triggerLine = window.innerHeight * 0.28;
      let current = 0;

      for (let i = 0; i < items.length; i += 1) {
        const rect = items[i].getBoundingClientRect();
        if (rect.top <= triggerLine) {
          current = i;
        } else {
          break;
        }
      }

      return current;
    };

    // Mobile: fixed dots — show only while images still fill the area above the peek card
    const updateMobileVisibility = () => {
      if (window.matchMedia(DESKTOP_MQ).matches) {
        dotsNav.classList.add('is-visible');
        dotsNav.hidden = false;
        return;
      }

      const rect = wrapper.getBoundingClientRect();
      const peekVar = getComputedStyle(document.documentElement)
        .getPropertyValue('--product-peek-h')
        .trim();
      const peekH = peekVar.endsWith('px') ? parseFloat(peekVar) : 176;
      const cardTop = window.innerHeight - peekH;

      // Gallery must still extend past the white card top — otherwise hide
      let inView = rect.bottom > cardTop + 16 && rect.top < cardTop - 8;

      // Also hide as soon as the real product card docks into the peek band
      const productCard = document.querySelector('.product-mobile-card');
      if (productCard) {
        const productTop = productCard.getBoundingClientRect().top;
        if (productTop <= cardTop + 2) inView = false;
      }

      dotsNav.classList.toggle('is-visible', inView);
      dotsNav.hidden = !inView;
    };

    const onScroll = () => {
      updateMobileVisibility();
      if (isClickScrolling) return;
      setActive(getActiveIndex());
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.galleryDot);
        const target = items[index];
        if (!target) return;

        isClickScrolling = true;
        setActive(index);
        // Instant scroll — smooth scroll + sticky UI feels like image snap on mobile
        target.scrollIntoView({ behavior: 'auto', block: 'start' });

        window.clearTimeout(clickScrollTimeout);
        clickScrollTimeout = window.setTimeout(() => {
          isClickScrolling = false;
          setActive(getActiveIndex());
          updateMobileVisibility();
        }, 100);
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  };

  const initAll = () => {
    document.querySelectorAll('[data-stacked-gallery]').forEach(initStackedGalleryDots);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
